import { graphql } from '@graphql/__generated'

export const GET_ACTIVE_MEMBERSHIPS_BY_COMPANY = graphql(`
  query GetActiveMembershipsByCompany($organisationName: String!) {
    getActiveMembershipsByCompany(name: $organisationName) {
      orderId
      orgName
      userId
      paid
      customerEmail
      timestamp
      lastUpdated
      priceId
    }
  }
`)
